import {
    /** FETCH GETCOUNTRIES  */
    FETCH_GETCOUNTRIES_FULFILLED,
    FETCH_GETCOUNTRIES_REJECTED,
    FETCH_GETCOUNTRIES_PENDING,
    RESET_GETCOUNTRIES,
  } from "../../actions/payment/getCountries";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETCOUNTRIES_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_GETCOUNTRIES_FULFILLED:
        return {
          ...state,
          getCountries: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_GETCOUNTRIES_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_GETCOUNTRIES:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  